module.exports = __webpack_public_path__ + "static/img/A.0eed7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/A.png
// module id = A7p/
// module chunks = 0